import React from 'react';
import { motion } from 'framer-motion';
import './About.css';
import catering from '../assets/images/catering.avif'

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="about-content">
          <motion.div 
            className="about-image"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <img src={catering} alt="Baked cakes and pastries" />
          </motion.div>
          <motion.div 
            className="about-text"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2>About Bubu’s Sweet Treats</h2>
            <p>Bubu’s Sweet Treats specialises in beautifully crafted cakes, fresh pastries, and event decorations. We bake with premium ingredients and deliver personalised designs for birthdays, weddings, and corporate events.</p>

            <div className="features">
              {[
                { icon: 'fas fa-award', title: 'Handmade Quality', desc: 'Every cake and pastry is handcrafted with care and attention to detail.' },
                { icon: 'fas fa-palette', title: 'Custom Designs', desc: 'Unique, personalised designs to match your event theme and preferences.' },
                { icon: 'fas fa-leaf', title: 'Fresh Ingredients', desc: 'We use fresh, locally sourced ingredients for the best flavour and texture.' }
              ].map((feature, index) => (
                <motion.div 
                  key={index}
                  className="feature"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.2, duration: 0.6 }}
                >
                  <div className="feature-icon">
                    <i className={feature.icon}></i>
                  </div>
                  <div className="feature-content">
                    <h4>{feature.title}</h4>
                    <p>{feature.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
          
          <motion.div 
            className="about-stats"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            {[
              { number: '5+', label: 'Years Experience' },
              { number: '1000+', label: 'Happy Customers' },
              { number: '100%', label: 'Satisfaction Rate' }
            ].map((stat, index) => (
              <motion.div 
                key={index}
                className="stat"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <h3>{stat.number}</h3>
                <p>{stat.label}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;